import moment from '@/moment-gp'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {

    VALID_MESSAGE_TYPES: [ 'TASK', 'COMMITMENT', 'GOAL', 'APPOINTMENT', 'SEQUENCE', 'CONTACT', 'FILE', 'IMAGE' ],

    create({ senderUserId, message, type = null }, data) {

      if ( type && !this.VALID_MESSAGE_TYPES.includes(type) ) {
        throw new Error('Invalid message type: ' + type)
      }

      let messageObject = {
        senderUserId: senderUserId,
        createdAt:    moment.currentTimeServer('REALTIMEDB'),
        message:      message,
        unread:       true,
        type:         type, // No type means messages
        isAdHoc:      null, // null, true, false
      };

      if ( type ) {
        Object.assign(
          messageObject,
          this.additional_type_specific_fields(type, data)
        );
      }

      return messageObject;
    },

    additional_type_specific_fields(type, data) {

      switch (type) {
        case 'TASK':
        return {
          taskId:             data.taskId || null,
          commitmentId:       data.commitmentId || null,  // REMOVE
          goalId:             data.goalId || null,
          memberId:           data.memberId || null,
        }

        case 'COMMITMENT':
        return {
          commitmentId:       data.commitmentId || null,
          goalId:             data.goalId || null,
        }

        case 'GOAL':
        return {
          goalId:             data.goalId || null,
        }
      }
    },

    fields: {
      senderUserId: { validate_bolt_type: 'UserID' },
      createdAt: { validate_bolt_type: 'ServerTimestamp' },
      message: { validate_bolt_type: 'String' },
      unread: { validate_bolt_type: 'Boolean' },
      type: { validate_bolt_type: 'String' },
      isAdHoc: { validate_bolt_type: 'Boolean' },
      taskId: { validate_bolt_type: 'AnyID' },
      commitmentId: { validate_bolt_type: 'AnyID' },  // REMOVE
      goalId: { validate_bolt_type: 'AnyID' },
      memberId: { validate_bolt_type: 'MemberID' },
    }
  }
};
